import styled from 'styled-components/macro';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PopoverArrow = styled(PopoverPrimitive.Arrow)`
  fill: ${({ theme }) => theme.colors.gray[7]};
  width: 12px;
  height: 6px;
  margin: 0 16px;
`;
